import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { PageShellComponent } from '@shared/components/page-shell/page-shell.component';

interface Person {
  name: string;
  linkedin?: string;
}

interface TeamArea {
  id: string;
  titleKey: string;
  descriptionKey: string;
  people: Person[];
}

@Component({
  selector: 'app-quem-somos-page',
  standalone: true,
  imports: [RouterLink, TranslocoPipe, LocalizedRouterLinkPipe, PageShellComponent],
  templateUrl: './quem-somos.page.html',
})
export class QuemSomosPage {
  protected readonly breadcrumb = [{ labelKey: 'nav.aboutUs' }];

  protected readonly teamAreas: TeamArea[] = [
    {
      id: 'viz',
      titleKey: 'pages.aboutUs.team.areas.visualization.title',
      descriptionKey: 'pages.aboutUs.team.areas.visualization.description',
      people: [
        { name: 'Letícia Valle', linkedin: 'https://www.linkedin.com/in/leticiamvalle/' },
        { name: 'Samyra Pereira', linkedin: 'https://www.linkedin.com/in/samyra-lima-pereira-6b0b9bb4/' },
        { name: 'Caio Oliveira', linkedin: 'https://www.linkedin.com/in/caiomcoliveira/' },
        { name: 'Lucas Valadão', linkedin: 'https://www.linkedin.com/in/valadao32/' },
        { name: 'Fernando Fogliato', linkedin: 'https://www.linkedin.com/in/fernandofogliato/' },
      ],
    },
    {
      id: 'gestao',
      titleKey: 'pages.aboutUs.team.areas.dataManagement.title',
      descriptionKey: 'pages.aboutUs.team.areas.dataManagement.description',
      people: [
        { name: 'Leonardo Pires', linkedin: 'https://www.linkedin.com/in/leonardo-vasconcelos-94073336/' },
        { name: 'Flávio Sousa', linkedin: 'https://www.linkedin.com/in/sousaflavio/' },
        { name: 'Danilo Santos' },
        { name: 'Otoniel Miranda' },
      ],
    },
    {
      id: 'analise',
      titleKey: 'pages.aboutUs.team.areas.analysis.title',
      descriptionKey: 'pages.aboutUs.team.areas.analysis.description',
      people: [
        { name: 'César Galvão', linkedin: 'https://www.linkedin.com/in/cesaraspgalvao' },
        { name: 'Leandro Claudio', linkedin: 'https://www.linkedin.com/in/leandrodelgrandeclaudio' },
        { name: 'Pedro Mello', linkedin: 'https://www.linkedin.com/in/pedro-h-mello-pereira-b893701b1' },
        { name: 'Weslley Rodrigues', linkedin: 'https://bit.ly/weslley-linkedin' },
        { name: 'Mirna Ramos', linkedin: 'https://www.linkedin.com/in/mirnatetzner' },
      ],
    },
    {
      id: 'assessoria',
      titleKey: 'pages.aboutUs.team.areas.advisory.title',
      descriptionKey: 'pages.aboutUs.team.areas.advisory.description',
      people: [{ name: 'Camila Kobayashi', linkedin: 'https://www.linkedin.com/in/camilakobayashi' }],
    },
    {
      id: 'coordenacao',
      titleKey: 'pages.aboutUs.team.areas.coordination.title',
      descriptionKey: 'pages.aboutUs.team.areas.coordination.description',
      people: [{ name: 'Pedro Masson', linkedin: 'https://www.linkedin.com/in/pedro-masson/' }],
    },
    {
      id: 'colaboradores-anteriores',
      titleKey: 'pages.aboutUs.team.areas.formerCollaborators.title',
      descriptionKey: 'pages.aboutUs.team.areas.formerCollaborators.description',
      people: [{ name: 'Iara Viana', linkedin: 'https://www.linkedin.com/in/iara-viana-794805a8' }],
    },
  ];
}
